// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"67b61d5fe1219071483a","339":"06ed3526a50be6f94131"}[chunkId] + ".js";
};